const ExportImportGuide = () => {

    return (
        <div>
            📦 2025년 8월 물류 수출입 가이드 <br /><br />
            1. 글로벌 물류 환경 개요<br /><br />

            항만 혼잡 완화 : 2024년 하반기까지 이어졌던 주요 항만(미국 LA/LB, 유럽 로테르담)의 적체가 점차 정상화되었음. <br />
            다만 성수기 출항(7~9월)에는 여전히 선복 부족과 운임 상승이 발생.<br /><br />

            운임 동향 : 미주 항로 및 유럽 항로는 성수기 서차지(PSS, Peak Season Surcharge)가 적용 중이며, <br />
            2025년 8월 평균 운임은 2024년 대비 8~12% 인상된 수준.<br /><br />

            친환경 규제 강화 : IMO(국제해사기구)의 CII/ETS 규제가 본격 적용되면서 저탄소 선박 및 친환경 운송 요구가 확대됨.

        </div>
    )
}
export default ExportImportGuide